import { Overrides } from '@material-ui/core/styles/overrides';

import { colors, colours, hexToRgba } from '@shared/theme/colours';

const focusTint = hexToRgba(colours.solid.black, 0.08);

export const initializeListItemOverrides = (config?: Overrides['MuiListItem']): Overrides['MuiListItem'] => {
  return {
    root: {
      '&.Mui-selected': {
        backgroundColor: colors.blue.lightest,

        '&:hover': {
          backgroundColor: colors.blue.lightest,
        },
      },
      // Focus tints whatever background the item has, as a selected item's background hides MUI's focus colour, and an
      // item whose tooltip wrapper takes focus in its place shows it too
      '&.Mui-selected.Mui-focusVisible, [role="option"]:focus-visible &': {
        backgroundImage: `linear-gradient(${focusTint}, ${focusTint})`,
      },
    },
    button: {
      '&:hover': {
        backgroundColor: colors.blue.lightest,
      },
    },
    ...config,
  };
};
